import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'

const TecdashboardMain = () => {

    useEffect(()=>{

        document.getElementById("usernametecD").innerHTML=localStorage.getItem('username')
        
    
      });
  return (
    <div className='tec-addmain'>
        {/* <div class="tec-hero"> 
  <div class="techero__title"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
</div> */}
   <main class="tecwelcomecontainer">
  <p>Hello , <div id="hello-tec"></div> <span id="usernametecD"> </span></p>
  <section class="tecwelcomeanimation">
    <div class="firsttec-danime"><div>Welcome To</div></div>
    <div class="secondtec-danime"><div>KDP Tec</div></div>
    <div class="thirdtec-danime"><div>Venture!</div></div>
  </section>
</main>
{/* <div class="tec-hero"> 
  <div class="techero__title"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
  <div class="teccube"></div>
</div> */}
   </div>
  )
}

export default TecdashboardMain
